var _class, _descriptor;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Service, { inject as service } from '@ember/service';
import { getOwner } from '@ember/application';
import * as Sentry from '@sentry/browser';
/**
 * This service is responsible for fetching and caching the MFE manifests.
 */
let SingleSpaManifest = (_class = class SingleSpaManifest extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "environment", _descriptor, this);
    _defineProperty(this, "cachedManifests", {});
    _defineProperty(this, "defaultLocalhostPort", '5173');
  }
  get config() {
    return getOwner(this).resolveRegistration('config:environment');
  }

  /**
   * Retrieves the contents of the manifest file for a specified MFE.
   *
   * This function checks if the manifest is already cached. If it is, it returns the cached
   * version. Otherwise, it fetches the manifest from the specified path.
   * @param manifestPath The path of the manifest file.
   * @param mfeName (Optional) The name of the MFE. This is used to fetch environment variables for local development.
   * @returns A promise that resolves to the manifest contents.
   */
  async getManifest(manifestPath, mfeName) {
    const manifest = this.cachedManifests[manifestPath];
    if (manifest) {
      return manifest;
    }
    const app = await this.fetchManifest(manifestPath, mfeName);
    this.cachedManifests[manifestPath] = app;
    return app;
  }
  async fetchManifest(manifestPath, mfeName) {
    const envConfig = mfeName ? this.config.dashboardMFE?.[mfeName] ?? {} : {};
    const endpoint = this.getEndpoint(manifestPath, {
      useLocalIntegration: envConfig.enabled,
      port: envConfig.localhostPort
    });
    const response = await fetch(endpoint).then(res => {
      if (res.ok) {
        return res.json();
      }
      throw new Error(`Failed to load manifest: ${res.status}`);
    }).catch(e => {
      Sentry.captureException(e);
    });
    return response.app;
  }
  getEndpoint(manifestPath, options) {
    const {
      isDevelopment,
      isProduction,
      isSandbox,
      isTesting
    } = this.environment;
    const useLocalIntegration = options?.useLocalIntegration ?? false;
    const port = options?.port ?? this.defaultLocalhostPort;
    if (isTesting) {
      return manifestPath;
    } else if (isDevelopment && useLocalIntegration) {
      return `http://localhost:${port}${manifestPath}`;
    } else if (isProduction || isSandbox) {
      return `https://app.squareup.com${manifestPath}`;
    } else {
      return `https://app.squareupstaging.com${manifestPath}`;
    }
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "environment", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
export { SingleSpaManifest as default };